import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Box } from '@mui/material';
import { RatingDay } from '../../../types/conditionRating';
import styles from './ConditionRatingsDay.module.scss';
import ConditionRatingsBars from '../../ConditionRatingsBars';

interface DayProps {
  className?: string;
  day: RatingDay;
  barHeight?: '4px' | '8px' | '10px' | '16px';
}

const ConditionRatingsDay: React.FC<DayProps> = (props) => {
  const { className, day, barHeight = '4px' } = props;

  const barStyle = useMemo(
    () => ({
      maxHeight: barHeight,
      minHeight: barHeight,
    }),
    [barHeight],
  );

  const wrapperClassName = useMemo(() => classNames(styles.wrapper, className), [className]);

  return (
    <Box className={styles.container}>
      <div className={wrapperClassName} style={barStyle} data-testid="condition-ratings-day">
        <ConditionRatingsBars barHeight={barHeight} bars={day} />
      </div>
    </Box>
  );
};

export default ConditionRatingsDay;
